import React from 'react';
import cn from 'clsx';

import Typography from '../typography/typography';

import styles from './vehicle-description.scss';

interface VehicleDescriptionProps {
  className?: string;
  make?: string;
  model?: string;
  renderAfterYearMake?: () => JSX.Element;
  rideHeight?: string;
  trim?: string;
  year?: string;
}

function VehicleDescription(props: VehicleDescriptionProps) {
  const {
    className = '',
    make,
    model,
    renderAfterYearMake,
    rideHeight,
    trim,
    year
  } = props;

  const shouldShowRideHeight = rideHeight && !/stock height/i.test(rideHeight);

  return (
    <div
      className={cn(styles['container'], `vehicle-description ${className}`)}
    >
      {(year || make) && (
        <Typography
          className={cn(
            styles['year-make-container'],
            'vehicle-description__year-make-container'
          )}
          size="small"
          tag="div"
        >
          <Typography
            className={cn(
              styles['vehicle-info'],
              'vehicle-description__year-make'
            )}
            tag="span"
            variant="H5"
            weight="black"
          >
            {year} {make}
          </Typography>
          {renderAfterYearMake?.()}
        </Typography>
      )}
      {(model || trim) && (
        <div
          className={cn(
            styles['model-trim-container'],
            'vehicle-description__model-trim-container'
          )}
        >
          <Typography
            className={cn(
              styles['vehicle-info'],
              'vehicle-description__model-trim'
            )}
            tag="span"
          >
            {model} {trim}
          </Typography>
        </div>
      )}
      {shouldShowRideHeight && (
        <>
          <hr
            className={cn(
              styles['ride-height-hr'],
              'vehicle-description__ride-height-hr'
            )}
          />
          <Typography
            className={cn(
              styles['ride-height'],
              'vehicle-description__ride-height'
            )}
            size="small"
            tag="div"
          >
            {rideHeight}
          </Typography>
        </>
      )}
    </div>
  );
}

export default VehicleDescription;
